'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.improveUnhandledRejectionString = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.betterRejectionString = betterRejectionString;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function betterRejectionString(reason) {
    var outputString;

    if (reason == null || typeof reason === 'string' || reason instanceof String) {
        outputString = reason;
    } else if (reason instanceof Error) {
        // Error.prototype.toString is already pretty good (it includes the error type and message)
        outputString = reason + '';
    } else if (reason.message != null) {
        // A error-like object
        outputString = reason.message;
    } else if (reason.responseText != null) {
        // An XHR or XHR-like object
        outputString = reason.responseText;
    } else if (reason.statusText != null) {
        // An XHR or XHR-like object
        outputString = reason.statusText;
    } else if (typeof reason === 'function') {
        outputString = 'Function: ' + reason.toString();
    } else if (reason.constructor != null && reason.constructor.name != null && reason.constructor.name !== 'Object' && reason.constructor.name !== 'Boolean' && reason.constructor.name !== 'Number' && reason.constructor.name !== 'Array' && reason.constructor.name !== 'Date') {
        // constructor.name can be a bit generic, but is useful for non-basic types such DOM/React events,
        // which often are not able to be stringified easily
        outputString = reason.constructor.name;
    } else if (!Object.keys || // Short circuit and don't get to Object.keys if it is missing
    (typeof reason === 'undefined' ? 'undefined' : _typeof(reason)) !== 'object' || // or if the reason isn't an object, while ...
    Object.keys(reason).length < 100 // Preventing us from stringify-ing giant objects
    ) {
            try {
                outputString = JSON.stringify(reason);
            } catch (e) {
                outputString = reason + '';
            }
        } else {
        outputString = reason + '';
    }

    return outputString;
}

var improveUnhandledRejectionString = exports.improveUnhandledRejectionString = function improveUnhandledRejectionString() {
    return _q2.default.customizeRejectionString = betterRejectionString;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-4.12/js/improveUnhandledRejectionString.js
// module id = 424
// module chunks = 0